export default "__VITE_ASSET__m1ZV7wQd__"